import { useCallback, useEffect, useState } from 'react'
import { PACKAGES as STATIC_PACKAGES } from '../data'
import { BASE_URL } from '../data/baseurl'



export function usePackages() {
  const [packages, setPackages] = useState(STATIC_PACKAGES)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const fetchPackages = useCallback(async () => {
    try {
      setLoading(true)
      const res = await fetch(`${BASE_URL}/packages`)
      if (!res.ok) throw new Error('Failed to fetch packages')
      const data = await res.json()
      if (Array.isArray(data) && data.length > 0) {
        const sorted = [...data].sort((a, b) => {
          if (a.createdAt && b.createdAt) {
            return new Date(b.createdAt) - new Date(a.createdAt);
          }
          return 0;
        });
        setPackages(sorted)
        setError(null)
      } else {
        setPackages(STATIC_PACKAGES)
      }
    } catch (err) {
      console.warn('API error fetching packages, falling back to static package list:', err)
      setPackages(STATIC_PACKAGES)
      setError(err)
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    fetchPackages()
  }, [fetchPackages])

  const indiaDest = packages.filter((p) => p.cat?.toLowerCase() === 'india')
  const longHaulDest = packages.filter((p) => p.cat?.toLowerCase() === 'international')
  const cityDest = packages.filter((p) => p.cat?.toLowerCase() === 'city')

  return {
    packages,
    indiaDest,
    longHaulDest,
    cityDest,
    loading,
    error,
    refetch: fetchPackages,
  }
}
